import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  Box,
  Flex,
  Heading,
  ListItem,
  Text,
  UnorderedList,
} from '@chakra-ui/react';
import Image from 'next/image';
import Link from 'next/link';

const ResourcesStatData = [
  {
    id: 1,
    title: 'IVCA Guidance Note on IPEV Valuation Guidelines',
    desc: "IVCA's comprehensive guidance note that adapts the International Private Equity and Venture Capital Valuation (IPEV) Guidelines to address unique challenges faced by Indian PE and VC firms, including diverse investment stages, complex capital structures, and evolving market dynamics.",
    imgSrc: '/svg/ivca-logo.svg', // You may need to update this path
    readLink:
      'https://static.levocdn.com/WGLBUT82/GuidanceNoteonIPEV-pKkMOluRtqJlN.pdf',
    date: 'March 2024',
  },
  {
    id: 2,
    title:
      'International Private Equity and Venture Capital Valuation Guidelines',
    desc: 'The globally recognized IPEV Guidelines that provide comprehensive framework for valuation of private equity and venture capital investments, endorsed by IVCA as the standard for Indian AIFs following SEBI circular requirements.',
    imgSrc: '/svg/ipev-logo.svg', // You may need to update this path
    readLink: 'https://static.levocdn.com/WGLBUT82/7044292958521180374.pdf',
    date: 'December 2022',
  },
];

const information = [
  {
    id: 1,
    title: 'Background',
    info_one:
      'On June 21, 2023, the Securities and Exchange Board of India (SEBI) issued a circular standardizing the valuation approach for Alternate Investment Funds (AIFs). The circular mandates that valuations must follow guidelines endorsed by an AIF industry association representing at least 33% of SEBI-registered AIFs. These guidelines were to be selected based on recommendations from the Alternative Investment Policy Advisory Committee (AIPAC), ensuring alignment with global best practices.',
    list: [],
    info_two: '',
  },
  {
    id: 2,
    title: 'IVCA Role',
    info_one:
      "The Indian Private Equity and Venture Capital Association (IVCA), recognized as the largest representative body for AIFs in India, was tasked with endorsing appropriate valuation guidelines. Acting on AIPAC's recommendation, IVCA officially endorsed the International Private Equity and Venture Capital Valuation (IPEV) Guidelines. This endorsement reflects IVCA's commitment to promoting transparency, consistency, and alignment with global standards in AIF valuation practices in India.",
    info_two: '',
    list: [
      {
        text: 'About IVCA',
        link: '/about-us',
        listing: [],
      },
      {
        text: 'IVCA Membership Benefits',
        link: '/membership/member-benefits',
        listing: [],
      },
      {
        text: 'IVCA Membership Application Form',
        link: '/membership/membership-form',
        listing: [],
      },
      {
        text: 'List of IVCA Members',
        link: '/membership',
        listing: [],
      },
    ],
  },
  {
    id: 3,
    title: 'Recognition by IPEV',
    info_one:
      'As part of this initiative, IVCA was formally acknowledged by IPEV as the Country Partner for India. This recognition positioned IVCA as the primary entity responsible for adapting and facilitating the implementation of these internationally accepted valuation standards within the Indian AIF ecosystem.',
    info_two: '',
    list: [],
  },
  {
    id: 4,
    title: 'India-Tailored Guidance Note',
    info_one:
      'Following its endorsement of the IPEV Guidelines, IVCA engaged extensively with relevant stakeholders—including fund managers, valuers, regulators, and industry experts—to create a tailored guidance note. This document adapted the IPEV principles to address unique challenges faced by Indian private equity and venture capital firms, including diverse investment stages, complex capital structures, and evolving market dynamics.',
    info_two:
      'The resulting IVCA Guidance Note on Valuation serves as a critical resource for ensuring consistent valuation practices that align with both international standards and local market realities.',
    list: [],
  },
  {
    id: 5,
    title: 'IPEV Resources',
    list: [
      {
        text: 'March 2024: IVCA – Guidance Note on IPEV Valuation Guidelines - ',
        link: 'https://static.levocdn.com/WGLBUT82/GuidanceNoteonIPEV-pKkMOluRtqJlN.pdf',
        listing: [],
      },
      {
        text: 'December 2022: International Private Equity and Venture Capital Valuation Guidelines (IPEV) - ',
        link: 'https://static.levocdn.com/WGLBUT82/7044292958521180374.pdf',
        listing: [],
      },
    ],
  },
  {
    id: 6,
    title: 'Communication Timeline',
    list: [
      {
        text: '3rd October 2024: Circular Queries on Valuation Framework - ',
        link: 'https://static.levocdn.com/WGLBUT82/Post19thSept24CircularQueriesonValuationFramework1-A8sF1FF1A3Cl.pdf',
        listing: [],
      },
      {
        text: '19th September 2024: Modification in framework for valuation of AIF portfolios - ',
        link: 'https://static.levocdn.com/WGLBUT82/ModificationinframeworkforvaluationofinvestmentportfolioofAIFs-JtaDEttPeutv.pdf',
        listing: [],
      },
      {
        text: '4th April 2024: Communication to members – Issues raised by IVCA and awaiting clarity - ',
        link: 'https://static.levocdn.com/WGLBUT82/4thApril2024-IVCAUpdateonDiscussionwithSEBIregardingCircularonStandardisedApproachtoValuationofPortfolioofAIFs-n3qBflrVhoox.pdf',
        listing: [],
      },
      {
        text: "28th March 2024: Email communication to members on IVCA's Valuation Guidance Note - ",
        link: "https://static.levocdn.com/WGLBUT82/IVCA's Valuation Guidance Note - Email Communication to Members-7182106885360473349.pdf",
        listing: [],
      },
      {
        text: '12th February 2024: Conflict Note on MF and IPEV submitted to Shri B Rajendran, ED, SEBI - ',
        link: 'https://static.levocdn.com/WGLBUT82/Letter to Shri B Rajendran, Executive Director - SEBI ___IVCA feedback - SEBI_Valuation_Circular_MF norms on 12th February, 2024-7182106885370090822.pdf',
        listing: [],
      },
      {
        text: '29th November 2023: IVCA Communication to members on Valuation Circular - ',
        link: 'https://static.levocdn.com/WGLBUT82/29th Nov, 2023- IVCA Communication to members on Valuation Circular-7179129624051163855.pdf',
        listing: [],
      },
      {
        text: '21st November 2023: Issues raised by IVCA and awaiting clarity - ',
        link: 'https://static.levocdn.com/WGLBUT82/Issues raised by IVCA and awaiting clarity-7179323175484900984.pdf',
        listing: [],
      },
      {
        text: '11th September 2023: IVCA Representation to SEBI seeking clarity on circular - ',
        link: 'https://static.levocdn.com/WGLBUT82/SEBI AIF Valuation Norms Comments Final-7179086187249645494.pdf',
        listing: [],
      },
      {
        text: '21st June 2023: SEBI Circular on standardised valuation of AIF portfolios - ',
        link: 'https://static.levocdn.com/WGLBUT82/SEBI Circular on Valuation of AIFâs investments-7179085858870261180.pdf',
        listing: [],
      },
    ],
  },
];

const ValuationInvestments = () => (
  <Flex flexDir="column">
    <Box bg="lightWhite">
      <Box
        maxW="900px"
        mx="auto"
        mb={{ xs: '40px', sm: '80px', md: '120px', lg: '150px' }}
        mt={{ xs: '50px', sm: '70px', md: '90px', lg: '70px' }}
      >
        <Heading mb="15px" textAlign="center" px={{ xs: '15px', sm: '10px' }}>
          Standardised Approach to Valuation of AIF Portfolio
        </Heading>
        <Text textAlign="center" px={{ xs: '20px', sm: '15px' }}>
          The Securities and Exchange Board of India (SEBI) issued a circular on
          June 21, 2023, standardizing the valuation approach for Alternative
          Investment Funds (AIFs). Following AIPAC recommendations, IVCA
          endorsed the International Private Equity and Venture Capital
          Valuation (IPEV) Guidelines to ensure alignment with global best
          practices.
        </Text>

        {/* Accordion */}
        <Accordion pt="46px" px="20px" allowToggle>
          {information.map((info) => (
            <AccordionItem key={info.id}>
              {({ isExpanded }) => (
                <>
                  <Text py="24px">
                    <AccordionButton _hover={{ bg: 'none' }}>
                      <Flex flex="1" textAlign="left">
                        <Text
                          variant="infoText"
                          color={isExpanded ? 'text.green' : 'text.textBlue'}
                          pr="20px"
                        >
                          {info.title}
                        </Text>
                      </Flex>
                      {isExpanded ? (
                        <Image
                          src="/svg/minus.svg"
                          alt="minus"
                          width={13}
                          height={13}
                        />
                      ) : (
                        <Image
                          src="/svg/Plus.svg"
                          alt="plus"
                          width={13}
                          height={13}
                        />
                      )}
                    </AccordionButton>
                  </Text>
                  <AccordionPanel pb={4}>
                    {(info.id === 1 || info.id === 3 || info.id === 4) && (
                      <>
                        <Text variant="disclaimerText">{info.info_one}</Text>
                        {info.info_two && (
                          <Text variant="disclaimerText">{info.info_two}</Text>
                        )}
                      </>
                    )}
                    {info.id === 2 && (
                      <>
                        <Text
                          fontWeight="400"
                          fontSize="16px"
                          color="text.textBlue"
                          textAlign="justify"
                        >
                          {info.info_one}
                        </Text>
                        <Text
                          fontWeight="600"
                          fontSize="17px"
                          color="text.greyPurple"
                          my="10px"
                        >
                          Read more about IVCA:
                        </Text>
                        <UnorderedList>
                          {info.list.map((item) => (
                            <ListItem my="12px">
                              <Text
                                fontWeight="400"
                                fontSize="16px"
                                color="text.textBlue"
                                as="span"
                              >
                                {item.text}
                              </Text>
                              <Link
                                aria-label={item.text}
                                href={item.link}
                                passHref
                              >
                                <Text
                                  as="span"
                                  color="primary.500"
                                  _hover={{
                                    textDecoration: 'underline',
                                    cursor: 'pointer',
                                  }}
                                >
                                  &nbsp;-&nbsp;CLICK HERE
                                </Text>
                              </Link>
                            </ListItem>
                          ))}
                        </UnorderedList>
                      </>
                    )}
                    {(info.id === 5 || info.id === 6) && (
                      <UnorderedList>
                        {info.list?.map((item) => (
                          <ListItem my="12px">
                            <Text variant="disclaimerText" as="span">
                              {item.text}
                            </Text>
                            <Link
                              aria-label={item.text}
                              href={item.link}
                              target="_blank"
                            >
                              <Text
                                color="primary.500"
                                _hover={{
                                  textDecoration: 'underline',
                                  cursor: 'pointer',
                                }}
                              >
                                CLICK HERE
                              </Text>
                            </Link>
                          </ListItem>
                        ))}
                      </UnorderedList>
                    )}
                  </AccordionPanel>
                </>
              )}
            </AccordionItem>
          ))}
        </Accordion>
      </Box>
    </Box>
  </Flex>
);

export default ValuationInvestments;
